import { useEffect, useState } from "react";
import { Star, Heart, FileImage } from "lucide-react";
import { api } from "../../lib/api";
import { BrutalCard, Badge, SectionTitle } from "../../components/common/Brutal";

export default function AdminFeedback() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/feedback").then(({ data }) => setItems(data));
  }, []);

  return (
    <div className="space-y-6" data-testid="admin-feedback">
      <SectionTitle kicker="Camper Feedback" title="Voices from the field" />

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((f) => (
          <BrutalCard key={f.id} className="p-4" data-testid={`feedback-${f.id}`}>
            <div className="flex items-center justify-between">
              <Badge color="orange">{f.user_name}</Badge>
              <div className="flex gap-0.5">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star
                    key={i}
                    className={`h-4 w-4 ${
                      i < f.rating ? "fill-[#FFB400] text-[#3D1E6D]" : "text-[#3D1E6D]/20"
                    }`}
                  />
                ))}
              </div>
            </div>
            <p className="mt-3 text-sm">{f.message}</p>
            {f.media_name && (
              <div className="mt-3 flex items-center gap-1 text-xs text-[#6B4E9E]">
                <FileImage className="h-3 w-3" /> {f.media_name}
              </div>
            )}
            <div className="mt-2 text-[10px] uppercase tracking-widest text-[#6B4E9E]">
              {new Date(f.created_at).toLocaleString()}
            </div>
          </BrutalCard>
        ))}
        {items.length === 0 && (
          <BrutalCard className="p-6 text-center text-[#6B4E9E] sm:col-span-2 lg:col-span-3">
            <Heart className="h-8 w-8 mx-auto text-[#E5247C] mb-2" />
            No feedback yet.
          </BrutalCard>
        )}
      </div>
    </div>
  );
}
